import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DashboardPage from "../pages/dashboard/DashboardPage";
import DashboardIndex from "../pages/dashboard/DashboardIndex";
import ActiveEvent from "../pages/dashboard/active-event/ActiveEvent";
import OverviewTab from "../pages/dashboard/overview/OverviewTab";
import OrdersTab from "../pages/dashboard/orders/OrdersTab";
import TicketsTab from "../pages/dashboard/tickets/TicketsTab";
import LoginPage from "../pages/login/LoginPage";
import HomePage from "../pages/home/HomePage";
import EventDetailsPage from "../pages/eventDetails/EventDetailsPage";
import { AuthProvider } from "./auth/AuthProvider";
import RequireAuth from "./auth/RouteGuard";
import ScannerPage from "../pages/scanner/ScannerPage";
import NotFoundPage from "../pages/not-found/NotFoundPage";
import PaymentSuccessPage from "../pages/payment/PaymentSuccessPage";
import TermsPage from "../pages/misc/TermsPage";
import PrivacyPage from "../pages/misc/PrivacyPage";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import DonationRedirect from "../pages/donations-temporary/DonationRedirect";

// changed by nev to redirect to xaghra
//import DonateXaghraBriju from "../pages/donations-temporary/donateXaghraBriju";

import DonationSuccessPage from "../pages/donations-temporary/donationSuccessPage";

export default function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/events" element={<HomePage />} />
            <Route path="/events/:eventSlug" element={<EventDetailsPage />} />
            <Route path="/donate/zghazagh-brijuzi-xaghrin" element={<DonationRedirect />} />
            <Route path="/donate/success" element={<DonationSuccessPage/>}/>
            <Route path="/success" element={<PaymentSuccessPage />} />
            <Route path="/terms-and-conditions" element={<TermsPage />} />
            <Route path="/privacy-policy" element={<PrivacyPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route element={<RequireAuth />}>
              <Route path="/dashboard" element={<DashboardPage />}>
                <Route index element={<DashboardIndex />} />
                <Route path=":eventSlug" element={<ActiveEvent />}>
                  <Route index element={<Navigate to="overview" replace />} />
                  <Route path="overview" element={<OverviewTab />} />
                  <Route path="orders" element={<OrdersTab />} />
                  <Route path="tickets" element={<TicketsTab />} />
                </Route>
              </Route>
              <Route path="/scanner" element={<ScannerPage />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
